import { format } from "date-fns";
import { generatePath, useNavigate, useOutletContext, useParams } from "react-router";

import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { GaiaMapUIOverlay } from "~/modules/map/components/GaiaMapUIOverlay";
import { MapButtonFitBounds } from "~/modules/map/components/MapButtonFitBounds";
import { AreasLayerV2 } from "~/modules/plannerV2/components/map-layers/AreasLayerV2";
import { PLANNER_MAP_PADDING } from "~/modules/plannerV2/constants/map";

import { PlannerV2ContextType } from "../types";
import { calculateAreaDetailBounds } from "./calculateBounds";
import { PlannerV2AreaDetail } from "./components/PlannerV2AreaDetailPanel";
import usePlannerV2AreaGetById from "./usePlannerV2AreaGetById";

export function PlannerV2AreaDetailScreen() {
    const { date, plannerAreaId } = useParams();
    if (!date || !plannerAreaId) throw new Error("Parameter `date` or `plannerAreaId` is unavailable");
    const selectedDate = parseStringToDate(date);

    const navigate = useNavigate();
    const { plannerSharedLeftPanel, plannerSharedBottomRightPanel } = useOutletContext<PlannerV2ContextType>();

    const { area } = usePlannerV2AreaGetById({
        id: plannerAreaId,
        onDate: format(selectedDate, "yyyy-MM-dd"),
    });

    const bounds = calculateAreaDetailBounds(area);

    return (
        <>
            <GaiaMapUIOverlay
                leftPanel={plannerSharedLeftPanel}
                rightPanel={
                    <PlannerV2AreaDetail
                        selectedDate={selectedDate}
                        area={area}
                        backHref=".."
                        visitOpenHref={plannerVisitId => generatePath("visits/:plannerVisitId", { plannerVisitId })}
                    />
                }
                bottomRightPanel={plannerSharedBottomRightPanel}
                bottomBar={<MapButtonFitBounds bounds={bounds} padding={PLANNER_MAP_PADDING} />}
            />

            {area && (
                <AreasLayerV2
                    areas={[area]}
                    areasById={new Map([[area.id, area]])}
                    selectedArea={area}
                    onAreaClick={selectedAreaId => {
                        navigate(generatePath("../areas/:plannerAreaId", { plannerAreaId: selectedAreaId }));
                    }}
                />
            )}
        </>
    );
}
